var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kd-loading"},[_c('div',{staticClass:"kd-spin--page kd-spin--indicator-container"},[_c('div',{staticClass:"kd-spin-dot-spin"},[_c('i',{staticClass:"kd-spin-dot-item"}),_c('i',{staticClass:"kd-spin-dot-item"}),_c('i',{staticClass:"kd-spin-dot-item"}),_c('i',{staticClass:"kd-spin-dot-item"})])])])
}]

export { render, staticRenderFns }